const DEFAULT_REMOTE_API_URL = 'https://braincamp-backend.onrender.com/api'

export const APP_ENV = import.meta.env.MODE || 'development'
export const IS_DEV = import.meta.env.DEV
export const API_TIMEOUT_MS = Number(import.meta.env.VITE_API_TIMEOUT) || 15000
export const SUPPORT_EMAIL =
  import.meta.env.VITE_SUPPORT_EMAIL || "info.braincamp@gmail.com";
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || ''

export const API_BASE_URL =
  import.meta.env.VITE_API_URL
  || (APP_ENV === 'production' || APP_ENV === 'uat'
    ? DEFAULT_REMOTE_API_URL
    : 'http://localhost:8080/api')

export const STORAGE_KEYS = {
  TOKEN: 'school_app_token',
  USER: 'school_app_user',
  SCHOOL_CONFIG: 'school_app_config',
  SESSION_MODE: 'school_app_session_mode',
}

export const LEGACY_STORAGE_KEYS = {
  TOKEN: 'bc_token',
  USER: 'bc_user',
  SCHOOL_CONFIG: 'bc_school_config',
}
